
import Button from '@/ui-kit/components/button';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import { StyleSizeType, StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ListingBookViewingCard from './card';

const ROWS_AMOUNT = 2;

export default {
  name: 'ListingBookViewingTimeSlots',
  components: {
    ListingBookViewingCard,
    Button,
    Icon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    activeIndex: {
      type: Number,
      required: true,
    },
    columnsAmount: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      ButtonFillType,
      StyleSizeType,
      StyleColorSchemeType,
      IconType,
      showAllItems: false,
    };
  },
  computed: {
    itemsToShow() {
      return this.showAllItems
        ? this.items
        : this.items.slice(0, this.defaultAmountOfItems);
    },
    defaultAmountOfItems() {
      return ROWS_AMOUNT * this.columnsAmount;
    },
    listStyle() {
      return {
        gridTemplateColumns: `repeat(${this.columnsAmount}, 1fr)`,
      };
    },
    toggleViewButtonTitle() {
      return this.showAllItems ? 'See fewer times' : 'See more times';
    },
  },
  methods: {
    getIsActive(index) {
      return index === this.activeIndex;
    },
    handleCardClick(index) {
      this.$emit('selectItem', index);
    },
    handleToggleView() {
      this.showAllItems = !this.showAllItems;
    },
  },
};
